import React, { useEffect, useState } from 'react'
import { format } from 'date-fns'
import { Note } from '../../../../models/_models'
import Table from '../../../common/Table'
import Button from '../../../Button'

const useNotes = () => {
  const [notes, setNotes] = useState([])
  const [total, setTotal] = useState()
  const [page, setPage] = useState(1)

  useEffect(() => {
    Note
      .stats({ total: 'count' })
      .per(50)
      .page(page)
      .order({ createdAt: 'desc' })
      .includes('school')
      .all()
      .then((res) => {
        setTotal(res.meta.stats.total.count)
        setNotes((prev) => ([
          ...prev, ...res.data.filter((datum) => !!datum.school),
        ]))

        if (res.data.length > 0) setPage((prev) => prev + 1)
      })
  }, [page])

  return { data: notes, total }
}

const Notes = () => {
  const { data, total } = useNotes()

  return (
    <>
      {total && (
        <h3>
          Number of notes:
          {' '}
          {total}
        </h3>
      )}
      <Table
        columns={[
          { Header: 'School', accessor: 'school' },
          { Header: 'Note', accessor: 'note' },
          { Header: 'Priority', accessor: 'priority' },
          { Header: 'Follow Up', accessor: 'createdAt' },
          { Header: 'Edit', accessor: 'edit' },
        ]}
        data={data.map((note) => {
          const {
            note: text,
            school,
            priority,
            createdAt,
          } = note

          return ({
            note: text,
            school: school && school.name,
            priority,
            createdAt: format(Date.parse(createdAt), 'M/d/u'),
            edit: (
              <a href={`/sales_calls/results/${school.id}`}>
                <Button rounded type="button">Edit</Button>
              </a>
            ),
          })
        })}
      />
    </>
  )
}

export default Notes
